/**
 * Global Imports
*/

import React, { useEffect, useContext } from 'react';

/**
 * Root Imports
*/

import { PageContext } from '~/components/PageProvider';
import { ShowRoleService } from '~/services/Role';

/**
 * Local Imports
*/

import { RoleContext } from '../../Providers/RoleProvider';
import { ResourceManage } from '../../Widgets/ResourceManage';

/**
 * Exports
*/

/**
 * 
 */
export function ShowRole(props) {
  /** Contexts **/
  
  const page = useContext(PageContext);
  
  /** Side-Effects **/

  useEffect(() => {
    handleMount();
  }, []);

  /** Event Handlers **/
  
  /**
   * 
   */
  const handleMount = () => {
    page.change({
      group: 'roles',
      breadcrumbs: ['Roles', 'View Role']
    });
  };
  
  /** Renderers **/

  /**
   * 
   */
  const renderResource = (resource) => (
    <div>The role { resource.title } was created at { resource.created_at }.</div>
  );
  
  /** Output **/
  
  return (
    <ResourceManage
      group='roles'
      context={ RoleContext }
      service={ ShowRoleService }
      renderResource={ renderResource }
    />
  );
}